import mainAPI from '../api/MainAPI';
import toasts from '../utils/toasts';
import scanViewController from './scanViewController';
import {
  administerDetailsPageRoute,
  administerOneDrug,
  checkIfResealRequired
} from '../components/pages/administerDetailsPage/AdministerDetailsPage';
import verifyController from './verifyController';
import models from '../model/models';
import DrugScanned from '../components/popups/drugScanned/DrugScanned';
import { getLastLocation } from '../utils/getLocation';
import dashboardController from "./dashboardController";

let BatchAdministerController = function () {
  this.administrations = [];
  this.incident_number = '';
  this.sending = false;
  this.reset = () => {
    this.administrations = [];
    this.sending = false;
    this.incident_number = null;
  };

  this.showScanner = () => {
    scanViewController.showScanner('Scan a Drug', 'Place the scan area on the code', this.handleScan);
  };

  this.handleScan = async (text) => {
    let drug = await mainAPI.drug.find_by_barcode({ barcode_id: text });
    if (!drug) return toasts.error('No drug found with that code');
		this.checkForExisting(text)
    this.showAdministerDetails(drug);
  };

	this.checkForExisting = (barcodeId) => {
		const existing = this.administrations.find((a) => {
			if (a.barcodeId === barcodeId) {
				return a;
			}
		})
		if(existing) {
			toasts.show(`Warning (${barcodeId}) is already in this batch.`);
		}
	}

  this.onAddAnother = (drugId, formValue, drugType, barcodeId, incident_number) => {
    this.incident_number = incident_number;
    this.insert({ drugId, formValue, drugType, barcodeId });
    this.showScanner();
  };

  this.upsert = (administration) => {
    const {drugId} = administration;
    let result = {updated: false, inserted: false}
    this.administrations = this.administrations.map((original) => {
      const {drugId: targetId} = original;
      if (targetId === drugId) {
        result = {...result, updated: true};
        return administration;
      }
      return original;
    });
    const {updated} = result;
    if (!updated) {
			return this.insert(administration)

    }
    return result;
  }

	this.insert = (administration) => {
		this.administrations.push(administration);
		return  {updated:false, inserted: true};
	};

  this.showAdministerDetails = (drug) => {
    scanViewController.hideScanner();
		window.popupController.temporaryResumeLast();
    window.f7.views.current.router.navigate(`${administerDetailsPageRoute}?force-navigate=${drug.id}`, {
      props: {
        incident_number: this.incident_number,
        drugBarcodes: this.barcodes({barcodeId: drug.barcode_id}),
        value: {
          id: drug.id,
          barcodeId: drug.barcode_id
        },
        onBackPress: () => {
          this.removeOne(drug.id);
        }
      }
    });
  };

  this.removeOne = (drugId) => {
    this.administrations = this.administrations.filter((admin) => {
      if (admin.drugId == drugId) {
        return false;
      }
      return true;
    });
  };

  this.getNumberOfAdministrations = () => {
    return this.administrations.length;
  };

  this.getAllDrugIds = (administrations) => {
    let allDrugIds = [];
    for (let i in this.administrations) {
      allDrugIds.push(this.administrations[i].drugId);
    }
    return allDrugIds;
  };

  this.addLastAdministration = async (drugId, formValue, drugType, barcodeId, incident_number) => {
    this.incident_number = incident_number;
    this.insert({drugId, formValue, drugType, barcodeId});
    const isControlledSubstance = this.administrations.find((administer) => {
      return models.drug_type.isVerifyRequired(administer.drugType);
    });
    let allDrugIds = this.getAllDrugIds(this.administrations);
    if (isControlledSubstance) {
      verifyController.start(async (verifier) => {
        await this.onVerify(verifier, allDrugIds);
      });
    } else {
      await this.onVerify({}, allDrugIds);
    }
  };

  this.administerDrugs = async (verifier) => {
    while (true) {
      const details = this.administrations.pop();
      if (!details) break;
      await this.administerOne(verifier, details);
    }
  };

  this.onVerify = async (verifier, allDrugIds) => {
    await this.administerDrugs(verifier);
    window.popupController.hide(DrugScanned);
    const drugs = await checkIfResealRequired(allDrugIds, verifier);
		let boxId = null;
		if (drugs && drugs[0]) {
			boxId = drugs[0].drug_box_id;
		}
		dashboardController.refresh(boxId);
    this.reset();
  };

  this.administerOne = async (verifier, administerDetails) => {
    const location = getLastLocation();
    await administerOneDrug(verifier, administerDetails.formValue, administerDetails.drugId, location);
  };

  this.barcodes = ({barcodeId} = {})=>{
    if (this.administrations.length === 0) {
        const result = (barcodeId) ? [barcodeId]: [];
        return result;
    }
    const result = this.administrations.map(({barcodeId}) => barcodeId);
    result.reverse();
    if(barcodeId && !result.includes(barcodeId)) result.unshift(barcodeId);
    return result;
  }
};

let batchAdministerController = new BatchAdministerController();

export default batchAdministerController;
